import React, { useState } from "react";
import InvoiceItemsTable from "../InvoiceItemsTable";
import { Segment, Divider, Dropdown, Checkbox, Button } from "semantic-ui-react";
import "./ShippingItem.css";
import { LimaShippingStatus } from "../../../../utils/Constants";

const ShippingItem = ({
  shipping,
  invoiceItems,
  shippingMethods,
  printShipping,
  isEditable,
  printCopy,
}) => {
  const [value, setValue] = useState(shipping.shippingMethod);
  const [isChecked, setIsChecked] = useState(true);
  const handleDropdownChange = (e, { value }) => setValue(value);
  const toggleCheck = () => setIsChecked(!isChecked);
  const handleButtonClick =
    !!printShipping && (() => printShipping(value, isChecked, shipping.shippingID));
  let shippingItems = shipping.items;
  let shippingInvoiceItems = invoiceItems.filter((x) =>
    shippingItems.some((z) => z.skuID == x.skuId)
  );
  for (var invoiceItem of shippingInvoiceItems) {
    let shippingItem = shippingItems.filter((z) => z.skuID == invoiceItem.skuId);
    if (shippingItem.length > 0) {
      invoiceItem.invoicedQuantity = shippingItem[0].deliveredQuantity;
    }
  }
  return (
    <Segment size="large">
      <div className="ShippingDetails">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <span>{`Shipping: ${shipping.shippingID}`}</span>
          {shipping.shippingStatus === LimaShippingStatus.Packad ? (
            <span style={{ color: "red", marginLeft: "5px" }}>(EJ UTSKRIVEN)</span>
          ) : null}
        </div>
        <span>{`Kollinummer: ${shipping.packageNumber}`}</span>
      </div>
      <Divider />
      <InvoiceItemsTable invoiceItems={shippingInvoiceItems} />
      <Divider />
      <div className="PrintContainer">
        {isEditable ? (
          <div className="PrintOptionsContainer">
            <Checkbox
              className="PrintOption"
              label="Makulera gammal etikett vid utskrift av ny"
              checked={isChecked}
              onChange={toggleCheck}
            />
            <Dropdown
              className="PrintOption"
              placeholder="[Välj fraktsätt]"
              selection
              options={shippingMethods}
              value={value}
              onChange={handleDropdownChange}
            />
          </div>
        ) : (
          <div></div>
        )}
        <Button className="PrintButton" onClick={handleButtonClick} disabled={!handleButtonClick}>{getPrintButtonText(printCopy)}</Button>
      </div>
    </Segment>
  );
};

const getPrintButtonText = (printCopy) => {
  if (printCopy) {
    return "Skriv ut kopia";
  } else {
    return "Skriv ut ny etikett";
  }
};

export default ShippingItem;
